module.exports = __webpack_public_path__ + "img/executive.e4134114.svg";